<template>
    <Page class="view-library-images">

        <State 
            :isLoading="isLoading" 
            :isEmpty="isEmpty" 
            subject="images">

            <AssetListScrollable 
                :list="images" 
                :context="true" 
                :overflow="false" 
                @select="handleSelect" />

        </State>

    </Page>
</template>

<script>
import { mapGetters, mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import AssetListScrollable from '@/components/common/asset/AssetListScrollable.vue'
import State from '@/components/common/state/State.vue'
import Page from '@/components/library/page/Page.vue'

export default {
    name: 'ViewLibraryImages',
    components: { 
        AssetListScrollable,
        State,
        Page
    },
    computed: {
        ...mapGetters('assets', [
            'isSynchronized'
        ]),
        ...mapGetters('library', [
            'getFilteredImageAssets'
        ]),
        isLoading() {
            return !this.isSynchronized
        },
        isEmpty() {
            return !Array.isArray(this.images) || this.images.length === 0
        },
        images() {
            return this.getFilteredImageAssets
        },
    },
    methods: {
        ...mapActions('windows', [
            'open'
        ]),
        handleSelect(asset) {
            this.open({ 
                component: "asset", 
                payload: { 
                    asset 
                } 
            })
        }
    }
}
</script>